module.exports = __webpack_public_path__ + "static/media/drinnen.a623fe4b.jpg";